module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    class: _vm.areaClass,
    attrs: {
      "columns": _vm.columns || 2,
      "label": "Data limite para resgate de pedidos"
    }
  }, [_c('el-date-picker', {
    staticClass: "order-retrieve-date",
    attrs: {
      "type": "date",
      "placeholder": "Data Limite",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.orderConfigs.retrieveDate),
      callback: function($$v) {
        _vm.$set(_vm.orderConfigs, "retrieveDate", $$v)
      },
      expression: "orderConfigs.retrieveDate"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Pedidos com a data de criação no marketplace anterior a configurada não serão resgatados para o Hub.")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4adfd81c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shared/OrderRetrieveDateConfiguration.vue
// module id = 3135
// module chunks = 0